import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Fragment, useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import moment from "moment";
import { Dialog, Transition } from "@headlessui/react";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import methodModel from "../../methods/methods";
import FormControl from "../../components/common/FormControl";
import Swal from "sweetalert2";

const TransactionDetail = () => {
  const { id } = useParams();
  const history = useNavigate();
  const [data, setData] = useState(null);
  const [resendCard, setResendCard] = useState({ modal: false, cardId: "", type: "", email: "", recipient_dialCode: "", recipient_mobileNo: "" });
  const [submitted, setSubmitted] = useState(false);
  const inValidEmail = methodModel.emailvalidation(resendCard?.email);
  const typeOptions = [
    { value: "email", label: "Email" },
    { value: "sms", label: "Mobile Number" }
  ]

  useEffect(() => {
    if (id) {
      getTransactionDetail();
    }
  }, [id]);

  const getTransactionDetail = () => {
    loader(true);
    ApiClient.get(`transactions/detail?id=${id}`).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    })
  };

  const handleChangePhone = (phone, country) => {
    const dialCode = country?.dialCode
    setResendCard((prev) => ({ ...prev, recipient_dialCode: dialCode, recipient_mobileNo: phone?.replace(dialCode, "") }))
  }

  const handleResendEmail = (e) => {
    e.preventDefault();
    setSubmitted(true)
    if (!inValidEmail && resendCard?.type?.value === "email") return
    if (!resendCard?.recipient_mobileNo && resendCard?.type?.value === "sms") return
    const payload = {
      ...resendCard,
      type: resendCard?.type?.value
    }
    delete payload.modal
    ApiClient.post(`payNow/resend/card`, payload).then(res => {
      if (res.success) {
        setResendCard({ modal: false, type: "", email: "", recipient_dialCode: "", recipient_mobileNo: "" })
        Swal.fire({
          icon: "success",
          title: "Card has been successfully reissued and is on its way."
        })
      }
    })
  }

  const openCardResendModal = (item) => {
    const typeData = typeOptions?.find((itm) => itm?.value === item?.type)
    setResendCard({
      modal: true,
      type: item?.type ? typeData : "",
      email: item?.recipient_email || "",
      recipient_dialCode: item?.recipient_dialCode || "",
      recipient_mobileNo: item?.recipient_mobileNo || "",
      cardId: item?._id || item?.id
    })
  }

  return (
    <>
      <Layout>
        <div className="wrapper_section bg-white shadow-box rounded-lg w-full p-4">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
          </div>
          <section className="px-4 py-6 bg-white rounded-lg border border-gray-200 shadow-md">
            <div className="mb-10 border-b pb-4">
              <h1 className="text-3xl font-bold text-gray-800">Transaction Detail</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm text-gray-700 mb-12">
              <div>
                <p className="text-gray-500 font-medium">Date</p>
                <p className="mt-1">{moment(data?.createdAt).format("DD MMM, YYYY")}</p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Sender Name</p>
                <p className="mt-1 capitalize">{data?.userId?.fullName || "--"}</p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Sender Email</p>
                <p className="mt-1">{data?.userId?.email || "--"}</p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Transaction Status</p>
                <p className={`mt-1 font-semibold capitalize ${data?.transaction_status === 'success' ? 'text-green-600' :
                  data?.transaction_status === 'failed' ? 'text-red-600' : 'text-yellow-600'
                  }`}>
                  {data?.transaction_status}
                </p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Tax</p>
                <p className="mt-1 font-semibold">6%</p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Total Amount</p>
                <p className="mt-1 font-semibold text-green-700">${data?.IncludingTaxAmount || data?.totalAmount || 0}</p>
              </div>
              {data?.isPromo === "yes" &&
                <>
                  <div>
                    <p className="text-gray-500 font-medium">Discount</p>
                    <p className="mt-1 font-semibold">{data?.promotype !== "percentage" && "$"} {data?.promoAmount} {data?.promotype === "percentage" && "%"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium">Paid Amount</p>
                    <p className="mt-1 font-semibold text-green-700">${data?.discountedAmount || 0}</p>
                  </div>
                </>
              }
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Card Purchase Details</h2>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="min-w-full text-sm divide-y divide-gray-200">
                <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                  <tr>
                    <th className="px-5 py-3 text-left">Card Name</th>
                    <th className="px-5 py-3 text-left">Recipient</th>
                    <th className="px-5 py-3 text-left">Email</th>
                    <th className="px-5 py-3 text-left">Mobile Number</th>
                    <th className="px-5 py-3 text-left">Qty</th>
                    <th className="px-5 py-3 text-left">Price</th>
                    <th className="px-5 py-3 text-left"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 text-gray-800">
                  {data?.[data?.customCardDetail?.length > 0 ? "customCardDetail" : "cardDetails"]?.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-5 py-3 capitalize">{item?.card_name || "--"}</td>
                      <td className="px-5 py-3 capitalize">{item?.recipient_name || "--"}</td>
                      <td className="px-5 py-3">{item?.recipient_email || "--"}</td>
                      <td className="px-5 py-3">{item?.recipient_mobileNo ? `+${item?.recipient_dialCode} ${item?.recipient_mobileNo}` : "--"}</td>
                      <td className="px-5 py-3">{item?.cartDetail?.quantity || 0}</td>
                      <td className="px-5 py-3">${item?.cartDetail?.price || 0}</td>
                      {data?.customCardDetail?.length > 0 &&
                        <td className="px-5 py-3">
                          <button
                            type="button"
                            onClick={() => openCardResendModal(item)}
                            className="bg-[#F58D18] text-white px-2 py-1 rounded-md"
                          >
                            Resend
                          </button>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </Layout>

      <Transition appear show={resendCard?.modal} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => setResendCard((prev) => ({ ...prev, modal: false }))}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex items-center justify-between">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      Resend Card
                    </Dialog.Title>
                  </div>
                  <form onSubmit={handleResendEmail}>
                    <div className="mt-6">
                      <div className="mb-3">
                        <label>Type <span className="text-red-600">*</span></label>
                        <Select
                          value={resendCard?.type}
                          onChange={e => setResendCard((prev) => ({ ...prev, type: e }))}
                          placeholder=""
                          required
                          options={typeOptions}
                        />
                      </div>
                      {resendCard?.type?.value === "email" &&
                        <div className="mb-3">
                          <FormControl
                            type="text"
                            name="email"
                            label="Email"
                            value={resendCard?.email}
                            onChange={(e) => setResendCard((prev) => ({ ...prev, email: e }))}
                            required
                          />
                          {submitted && !inValidEmail ? <span className="text-red-600">Please enter valid email</span> : null}
                        </div>
                      }
                      {resendCard?.type?.value === "sms" &&
                        <div className="mb-3">
                          <label>Mobile Number<span className="text-red-600">*</span></label>
                          <PhoneInput
                            country={"us"}
                            value={resendCard?.recipient_mobileNo ? resendCard?.recipient_dialCode + resendCard?.recipient_mobileNo : null}
                            enableSearch={true}
                            inputProps={{ required: true, autoComplete: "one-time-code" }}
                            onChange={(phone, country) => handleChangePhone(phone, country)}
                          />
                          {submitted && !resendCard?.recipient_mobileNo ? <span className="text-red-600">Mobile Number is required</span> : null}
                        </div>
                      }
                    </div>
                    <div className="mt-6 mb-2 flex items-center gap-4 justify-end">
                      <button type="button" onClick={() => setResendCard((prev) => ({ ...prev, modal: false }))} className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2">
                        Close
                      </button>
                      <button type="submit" className="bg-[#F58D18] text-white px-2 py-1 rounded-md">Send</button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default TransactionDetail;